// Node Module Imports
import React from 'react'

import { Breadcrumb } from 'gatsby-plugin-breadcrumb'
import htmr from 'htmr'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { colors, fontSize } from '../../style/design-system'

const Breadcrumbs = ({ className, customCrumbs, pageContext }) => {
  let crumbs
  const regex = new RegExp('-', 'g')

  if (customCrumbs) {
    crumbs = customCrumbs
  }
  else {
    crumbs = pageContext.breadcrumb.crumbs
  }

  crumbs = crumbs.map((crumb) => {
    if (typeof crumb.crumbLabel === 'string') {
      crumb.crumbLabel = htmr(crumb.crumbLabel.toLowerCase().replace(regex, ' '))
    }
    crumb.pathname = crumb.pathname[crumb.pathname.length - 1] == '/'
      ? crumb.pathname : `${crumb.pathname}/`
    return crumb
  })

  return (
    <div className={`${className} py-8`}>
      <Breadcrumb
        crumbs={crumbs}
        crumbSeparator=" > " />
    </div>
  )
}

Breadcrumbs.propTypes = {
  className: PropTypes.string,
  customCrumbs: PropTypes.arrayOf(PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    crumbLabel: PropTypes.string.isRequired,
  })),
  pageContext: PropTypes.object,
}

Breadcrumbs.defaultProps = {
  className: '',
}

export default styled(Breadcrumbs)`

  font-size: ${fontSize.e};

  .breadcrumb__list {
    list-style: none;
    margin: 0;
    padding: 0;
    text-transform: capitalize;

    a {
      color: ${colors.dev.gray.c()};
    }
  }

  .breadcrumb__list__item {
    display: inline-block;
  }

  .breadcrumb__link__active {
    font-weight: 900;
    // text-decoration: underline;
  }

`
